import CoreuiController from "../lib/coreui-controller"
import LoadingButton from "../coreui/loading-button"

export default class CoreuiLoadingButtonController extends CoreuiController {
  static Component = LoadingButton
}
